<button mat-icon-button [matTooltip]="tooltip" [color]="color" (click)="onClick()">
  <img src="assets/images/icons/icon-clone.png" alt="Button Image" height="17">
</button>
